import { render } from "./AddDocumentToCompanyAdmin.vue?vue&type=template&id=b9e6facc&scoped=true&ts=true"
import script from "./AddDocumentToCompanyAdmin.vue?vue&type=script&lang=ts"
export * from "./AddDocumentToCompanyAdmin.vue?vue&type=script&lang=ts"

import "./AddDocumentToCompanyAdmin.vue?vue&type=style&index=0&id=b9e6facc&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e6facc"]])

export default __exports__